var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { useTheme } from "styled-components";
import { border, color, maxWidth, minWidth, width, } from "styled-system";
import { StatusMessage } from "./StatusMessage";
const StyledTable = styled.table `
  ${color}
  ${border}
  ${width}
  ${maxWidth}
  ${minWidth}

  border-collapse: collapse;
`;
StyledTable.defaultProps = {
    cellPadding: 0,
};
const RelativeContainer = styled.div `
  position: relative;
  width: 100%;
  overflow-x: auto;
  min-height: ${({ theme }) => theme.sizes[6]}px;

  /* Prevent corners from overflowing when Table is rendered within a Card component */
  &:last-child {
    border-bottom-left-radius: var(--card-border-radius, "0px");
    border-bottom-right-radius: var(--card-border-radius, "0px");
  }
`;
export const Table = (_a) => {
    var { errorMessage } = _a, rest = __rest(_a, ["errorMessage"]);
    const { colors: { tableColors }, } = useTheme();
    return (React.createElement(RelativeContainer, null,
        errorMessage && React.createElement(StatusMessage, null, errorMessage),
        React.createElement(StyledTable, Object.assign({ backgroundColor: tableColors.tableBackground, borderColor: tableColors.tableBorder }, rest))));
};
